import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction, useState } from "react";
import UnForm from "../../../Components/Form";
import OrSpinner from "../../../Components/Utils/OrSpinner";
import { ListarEmpreendimentosController } from "../../../Controllers/Geral/Produtos/ProdutosControllers";
import {
    CadastrarCompromissoDisponivelVistoriaController,
    ListarHorariosDisponiveisController,
} from "../../../Controllers/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelController";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { ICompromissoDisponivelVistoria } from "../../../Interfaces/VistoriaEntregaChaves/CompromissoDisponivel/CompromissoDisponivelInterfaces";
import { ListarUsuariosAtivosController } from "../../../Controllers/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasController";
import { IUsuariosComAcessoResponse } from "../../../Interfaces/AssistenciaTecnica/Atendimento/ApontamentoHoras/ApontamentoHorasInterfaces";
import { useModuloInfo } from "../../../Context/ModuloInfo";

interface IDisponibilidadeVistoriaProps {
    setShow?: Dispatch<SetStateAction<boolean>>;
}

export default function DisponibilidadeVistoria(
    props: IDisponibilidadeVistoriaProps
) {
    const [data, setData] = useState("");
    const [idProduto, setIdProduto] = useState(0);

    const [usuario, setUsuario] = useState<string>("");
    const [usuariosAtivos, setUsuariosAtivos] = useState<
        IUsuariosComAcessoResponse[] | undefined
    >([{} as IUsuariosComAcessoResponse]);

    const {
        execute: cadastrarCompromissoDisponivel,
        loading: cadastrarCompromissoDisponivelLoading,
    } = useAsyncCallback(CadastrarCompromissoDisponivelVistoriaController);

    const { id } = useModuloInfo();

    const {
        value: compromissoDisponivelHorario,
        loading: compromissoDisponivelHorarioLoading,
        execute: ListarHorariosDisponiveis,
    } = useAsyncEffect(async () => {
        if (data && idProduto && usuario) {
            const res = await ListarHorariosDisponiveisController(
                data,
                idProduto,
                Number(usuario)
            );

            setHorariosSelecionados(
                res
                    ?.filter((compromisso) => compromisso.FL_AGENDADO)
                    .map(
                        (compromisso) =>
                            compromisso.ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO
                    )
            );

            if (
                res?.filter((compromisso) => compromisso.FL_AGENDADO).length ===
                res?.length
            ) {
                setHorariosSelecionados(
                    res.map(
                        (resp) =>
                            resp.ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO
                    )
                );
                setTodosHorariosSelecionados((prevState) => !prevState);
            }
            return res;
        }
    }, [data, idProduto, usuario]);

    const handleListagemUsuariosAtivos = async () => {
        if (idProduto && idProduto !== 0 && data && data !== "") {
            setUsuariosAtivos(await ListarUsuariosAtivosController(id ?? 0));
        }
    };

    useAsyncEffect(async () => {
        if (data && idProduto) {
            return handleListagemUsuariosAtivos();
        }
    }, [data, idProduto]);

    function handleCadastrarVistoria(formData: ICompromissoDisponivelVistoria) {
        cadastrarCompromissoDisponivel({
            FL_ATIVO: true,
            DT_INICIO: formData.DT_INICIO,
            ID_COMPROMISSO_DISPONIVEL_VISTORIA:
                formData.ID_COMPROMISSO_DISPONIVEL_VISTORIA,
            ID_PRODUTO: formData.ID_PRODUTO,
            ID_USUARIO: Number(usuario),
            idsHorarios: horariosSelecionados as [number],
        }).then(() => {
            ListarHorariosDisponiveis();
        });
    }

    const [todosHorariosSelecionados, setTodosHorariosSelecionados] =
        useState(false);
    const [horariosSelecionados, setHorariosSelecionados] = useState<
        number[] | undefined
    >([]);

    const handleSelecionarTodosHorarios = () => {
        setTodosHorariosSelecionados(!todosHorariosSelecionados);
        if (!todosHorariosSelecionados) {
            if (compromissoDisponivelHorario) {
                const todosHorarios = compromissoDisponivelHorario.map(
                    (horarioDisponivel) =>
                        horarioDisponivel.ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO
                );
                setHorariosSelecionados(todosHorarios);
            }
        } else {
            setHorariosSelecionados([]);
        }
    };

    const handleCheckboxChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = event.target.value;

        setHorariosSelecionados((prevSelectedHorarios) => {
            if (prevSelectedHorarios?.includes(Number(value))) {
                const filterHorarioSelecionado = prevSelectedHorarios.filter(
                    (item) => item !== Number(value)
                );
                if (filterHorarioSelecionado?.length === 0) {
                    setTodosHorariosSelecionados(false);
                }
                return filterHorarioSelecionado;
            } else {
                return [...(prevSelectedHorarios ?? []), Number(value)];
            }
        });
    };

    return (
        <div>
            <UnForm handleSubmit={handleCadastrarVistoria}>
                <div className="d-flex form-row justify-content-between col-12 mt-5 p-0 m-0">
                    <div className="col-4 pl-0 ml-0 form-group">
                        <UnForm.LazySelect
                            label="Empreendimento"
                            controller={ListarEmpreendimentosController}
                            getDS={(e) => e.DS_EMPREENDIMENTO}
                            getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                            name="ID_PRODUTO"
                            onChange={(e) =>
                                setIdProduto(Number(e.target.value))
                            }
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>

                    <div className="col-4 form-group">
                        <UnForm.Input
                            label="Data"
                            name="DT_INICIO"
                            type="date"
                            onChange={(e) => setData(e.target.value)}
                        />
                    </div>
                    <UnForm.Select
                        label={
                            idProduto && idProduto !== 0 && data && data !== ""
                                ? "Atribuído a"
                                : ""
                        }
                        name="ID_USUARIO"
                        className={`form-control placeholder-dark-50`}
                        wrapperClassName="col-md-4 col-lg-3"
                        hidden={
                            idProduto && idProduto !== 0 && data && data !== ""
                                ? false
                                : true
                        }
                        onChange={(e) => setUsuario(e.target.value)}
                    >
                        <option></option>
                        {usuariosAtivos?.map((usuario) => (
                            <option
                                value={usuario.ID_USUARIO}
                                key={usuario.ID_USUARIO}
                            >
                                {usuario.DS_NOME}
                            </option>
                        ))}
                    </UnForm.Select>
                    {/* Adicionar um LazySelect de Tecnicos!
                    <div className="col-4 pr-0 mr-0 form-group">
                        <UnForm.LazySelect
                            label="TECNICO"
                            controller={ListarEmpreendimentosController}
                            getDS={(e) => e.DS_EMPREENDIMENTO}
                            getKeyValue={(e) => e.ID_EMPREENDIMENTO}
                            name="ID_PRODUTO"
                            onChange={(e) =>
                                setIdProduto(Number(e.target.value))
                            }
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div> */}

                    <div className="d-flex justify-content-center align-items-center col-12 flex-column mt-3 mb-3 card p-4 gutter-b">
                        <OrSpinner
                            loading={compromissoDisponivelHorarioLoading}
                            spinner="capys"
                        >
                            <label className="mt-3">Horários Disponíveis</label>
                            {(compromissoDisponivelHorario?.length ??
                                [].length) > 0 && (
                                <button
                                    type="button"
                                    onClick={handleSelecionarTodosHorarios}
                                    className="btn btn-primary mb-3"
                                >
                                    {todosHorariosSelecionados
                                        ? "Remover selecionados"
                                        : "Selecionar todos"}
                                </button>
                            )}

                            <div className="d-flex row flex-wrap col-10 g-5 justify-content-center align-items-center mt-3">
                                {compromissoDisponivelHorario?.map(
                                    (horarioDisponivel) => (
                                        <label
                                            key={
                                                horarioDisponivel.ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO
                                            }
                                        >
                                            <UnForm.Input
                                                name="idsHorarios"
                                                type="checkbox"
                                                style={{
                                                    height: 35,
                                                    width: 35,
                                                }}
                                                label={
                                                    horarioDisponivel.DS_HORARIO
                                                }
                                                value={
                                                    horarioDisponivel.ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO
                                                }
                                                checked={horariosSelecionados?.includes(
                                                    horarioDisponivel.ID_COMPROMISSO_VISTORIA_DISPONIVEL_HORARIO
                                                )}
                                                onChange={handleCheckboxChange}
                                                defaultChecked={
                                                    (horarioDisponivel.FL_ATIVO &&
                                                        horarioDisponivel.FL_AGENDADO) ||
                                                    (!horarioDisponivel.FL_ATIVO &&
                                                        horarioDisponivel.FL_AGENDADO)
                                                }
                                                disabled={
                                                    !horarioDisponivel.FL_ATIVO &&
                                                    horarioDisponivel.FL_AGENDADO
                                                }
                                            />
                                        </label>
                                    )
                                )}
                            </div>
                        </OrSpinner>
                    </div>
                </div>

                <div className="d-flex col-12 justify-content-center mt-10">
                    <UnForm.SubmitButton
                        icon={faPaperPlane}
                        noDiv={true}
                        loadingSize="sm"
                        color="primary"
                        loading={cadastrarCompromissoDisponivelLoading}
                        className="mt-3"
                        wrapperClassName="col-12 justify-content-end align-itens-end"
                        disabled={
                            idProduto &&
                            data &&
                            usuario &&
                            usuario !== "" &&
                            usuario.length > 0
                                ? false
                                : true
                        }
                    >
                        Atualizar Horários Disponíveis
                    </UnForm.SubmitButton>
                </div>
            </UnForm>
        </div>
    );
}
